import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0a71d29f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a71d29f"]])

export default __exports__